/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { CommentContainer_comment$ref } from "./CommentContainer_comment.graphql";
import { LocalReplyListContainer_comment$ref } from "./LocalReplyListContainer_comment.graphql";
import { UserTagsContainer_comment$ref } from "./UserTagsContainer_comment.graphql";
declare const _ConversationThreadContainer_comment$ref: unique symbol;
export type ConversationThreadContainer_comment$ref = typeof _ConversationThreadContainer_comment$ref;
export type ConversationThreadContainer_comment = {
    readonly id: string;
    readonly rootParent: {
        readonly id: string;
        readonly author: {
            readonly id: string;
            readonly username: string | null;
        } | null;
        readonly createdAt: string;
        readonly " $fragmentRefs": UserTagsContainer_comment$ref;
    } | null;
    readonly parentCount: number;
    readonly parents: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly id: string;
                readonly " $fragmentRefs": CommentContainer_comment$ref & LocalReplyListContainer_comment$ref;
            };
        }>;
    };
    readonly " $fragmentRefs": CommentContainer_comment$ref;
    readonly " $refType": ConversationThreadContainer_comment$ref;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v1 = ({
        "kind": "FragmentSpread",
        "name": "CommentContainer_comment",
        "args": null
    } as any);
    return {
        "kind": "Fragment",
        "name": "ConversationThreadContainer_comment",
        "type": "Comment",
        "metadata": {
            "connection": [
                {
                    "count": "count",
                    "cursor": "cursor",
                    "direction": "backward",
                    "path": [
                        "parents"
                    ]
                }
            ]
        },
        "argumentDefinitions": [
            {
                "kind": "LocalArgument",
                "name": "count",
                "type": "Int!",
                "defaultValue": 0
            },
            {
                "kind": "LocalArgument",
                "name": "cursor",
                "type": "Cursor",
                "defaultValue": null
            }
        ],
        "selections": [
            (v0 /*: any*/),
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "rootParent",
                "storageKey": null,
                "args": null,
                "concreteType": "Comment",
                "plural": false,
                "selections": [
                    (v0 /*: any*/),
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "author",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "User",
                        "plural": false,
                        "selections": [
                            (v0 /*: any*/),
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "username",
                                "args": null,
                                "storageKey": null
                            }
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "createdAt",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "UserTagsContainer_comment",
                        "args": null
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "parentCount",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": "parents",
                "name": "__ConversationThread_parents_connection",
                "storageKey": null,
                "args": null,
                "concreteType": "CommentsConnection",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "CommentEdge",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Comment",
                                "plural": false,
                                "selections": [
                                    (v0 /*: any*/),
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "__typename",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    (v1 /*: any*/),
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "LocalReplyListContainer_comment",
                                        "args": null
                                    }
                                ]
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "cursor",
                                "args": null,
                                "storageKey": null
                            }
                        ]
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "pageInfo",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PageInfo",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "hasPreviousPage",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "startCursor",
                                "args": null,
                                "storageKey": null
                            }
                        ]
                    }
                ]
            },
            (v1 /*: any*/)
        ]
    } as any;
})();
(node as any).hash = '735b4646498097adc7cc0e7b941fc95c';
export default node;
